import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListPayloadState } from '@app-store/slices/companyStatistics/list'

interface TaskAction extends Action {
    payload: IListPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.list

function* listCompantStatisticsSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* listCompantStatisticsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listCompantStatisticsSagaTask)
}

export default listCompantStatisticsSaga
